export default __webpack_public_path__ + "static/media/processwire.a8677078.svg";